//
// Imports
//

import { z } from "zod";

//
// Schemas
//

const BooleanSchema = z.unknown()
	.transform((value, context) =>
	{
		if (value === "1" || value === 1 || value === "true" || value === true)
		{
			return true;
		}

		if (value === "0" || value === 0 || value === "false" || value === false)
		{
			return false;
		}

		context.addIssue(
			{
				code: z.ZodIssueCode.custom,
				message: "Invalid boolean value.",
				fatal: true,
			});

		return z.NEVER;
	});

export const StoreSchema = z.object(
	{
		"global::default_markup_type": z.enum([ "bbcode", "markdown" ]),
		"global::disable_swear_filter": BooleanSchema,
		"global::enable_developer_mode": BooleanSchema,
		"global::long_numbers": BooleanSchema,
		"global::theme": z.enum([ "auto", "light", "dark" ]),

		"forum::compact_forum_topic_listing": BooleanSchema,
		"forum::muted_forum_topic_flairs": BooleanSchema,

		"safety_tunnel::disable_warnings": BooleanSchema,

		"experimental::lws_pjax": BooleanSchema,
	});

//
// Types
//

export type Store = z.infer<typeof StoreSchema>;